import {
  INCLUDED,
  EXCLUDED,
  NOTAPPLICABLE,
} from "@/constants/common.constants";

export const adBoolToString = (adOn) => {
  if (adOn === null) return NOTAPPLICABLE;
  return adOn ? INCLUDED : EXCLUDED;
};

export const adStringToBool = (adString) => {
  if (adString === NOTAPPLICABLE) return null;
  return adString === INCLUDED;
};
